"use client";

import { type BurnStatus } from "@/lib/burn";

const SOLSCAN_URL = "https://solscan.io";

interface BurnStatusOverlayProps {
  status: BurnStatus;
}

export function BurnStatusOverlay({ status }: BurnStatusOverlayProps) {
  // Only show overlay for in-progress states
  if (status.stage === "success" || status.stage === "error") {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50">
      <div className="flex flex-col items-center gap-4 p-8">
        {/* Spinner */}
        <div className="w-12 h-12 border-3 border-[#222] border-t-[#f9cd4f] rounded-full animate-spin" />

        {/* Message */}
        <div className="text-white text-center">{status.message}</div>

        {/* Solscan link if we have a signature */}
        {status.signature && (
          <a
            href={`${SOLSCAN_URL}/tx/${status.signature}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#f9cd4f] text-sm hover:underline"
          >
            View on Solscan ↗
          </a>
        )}
      </div>
    </div>
  );
}
